<template>
  <sui-container text text-align="center">
    <h2 as="sui-header">{{ $t('strPleaseCheck') }}</h2>
    <sui-table>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="2">{{ $t('labelProduct') }}</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body>
        <sui-table-row>
          <sui-table-cell style="width: 50%">1x <strong>{{ $t(this.$store.getters.currentVoucher.name) }}</strong></sui-table-cell>
          <sui-table-cell><i18n-n :value="this.$store.getters.currentVoucher.price/100" format="currency" locale="de-DE"></i18n-n></sui-table-cell>
        </sui-table-row>
      </sui-table-body>
    </sui-table>

    <sui-table>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="2">{{ $t('labelMail') }}</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelMailAdress') }}</sui-table-cell>
          <sui-table-cell>{{current.mail}}</sui-table-cell>
        </sui-table-row>
      </sui-table-body>
    </sui-table>

    <sui-table v-if="current.smsEnable == 1">
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="2">{{ $t('labelSMS') }}</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelSubmitSMS') }}</sui-table-cell>
          <sui-table-cell>
            {{ $t('yes') }}
          </sui-table-cell>
        </sui-table-row>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelPhoneNo') }}</sui-table-cell>
          <sui-table-cell>{{current.smsPrefix}} {{current.smsValue}}</sui-table-cell>
        </sui-table-row>
      </sui-table-body>
    </sui-table>


    <sui-table>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="2">{{ $t('labelInvoiceDetails') }}</sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelCompany') }}	</sui-table-cell>
          <sui-table-cell>{{current.company}}</sui-table-cell>
        </sui-table-row>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelFirstName') }}	</sui-table-cell>
          <sui-table-cell>{{current.firstName}}</sui-table-cell>
        </sui-table-row>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelLastName') }}	</sui-table-cell>
          <sui-table-cell>{{current.lastName}}</sui-table-cell>
        </sui-table-row>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelStreet') }}	</sui-table-cell>
          <sui-table-cell>{{current.street}}</sui-table-cell>
        </sui-table-row>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelZip') }}	</sui-table-cell>
          <sui-table-cell>{{current.zip}}</sui-table-cell>
        </sui-table-row>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelCity') }}	</sui-table-cell>
          <sui-table-cell>{{current.city}}</sui-table-cell>
        </sui-table-row>
      </sui-table-body>
    </sui-table>

    <sui-table>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell colspan="2"></sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelAcceptedContition') }}</sui-table-cell>
          <sui-table-cell>
            <template v-if="current.acceptConditions == 1">
              {{ $t('yes') }}
            </template>
            <template v-else>
              {{ $t('no') }}
            </template>
          </sui-table-cell>
        </sui-table-row>
        <sui-table-row>
          <sui-table-cell style="width: 50%">{{ $t('labelAcceptedPrivacy') }}</sui-table-cell>
          <sui-table-cell>
            <template v-if="current.acceptPrivacy == 1">
              {{ $t('yes') }}
            </template>
            <template v-else>
              {{ $t('no') }}
            </template>
          </sui-table-cell>
        </sui-table-row>
      </sui-table-body>
    </sui-table>
    <sui-message error v-if="error">
      <sui-message-header>Fehler</sui-message-header>
      {{ error }}
    </sui-message>
    <div class="ui fluid buttons">
      <sui-button @click="clickBack">{{ $t('btnBack') }}</sui-button>
      <sui-button @click="clickBuy" color="red">{{ $t('btnBuy') }}</sui-button>
    </div>
  </sui-container>
</template>

<script>
  import StorageService from '@/services/StorageService.js';
  import ApiService from '@/services/ApiService.js'
  export default {
    name: 'CheckForm',
    props: ['current'],
    components: {
      ApiService,
      StorageService
    },
    data() {
      return {
    error: false
      }
    },
    methods: {
      clickBack(event) {
        if (event) {
          event.preventDefault()
        }
        this.$emit('goBack');
      },
      async clickBuy() {
        let response = await ApiService.postStartTransaction({ ...this.current, id: this.$store.getters.currentVoucher.id })

        if (response.status == 200) {
          this.error = false;
          this.track()
          window.location.href = response.data.url;
        } else {
          this.$swal(this.$t('error'), this.$t(response.data.error), 'error')
        }       
      },
      track() {
        if (StorageService.isCookieStatisticsAccepted()) {
          
          this.$gtag.query('event', 'checkout_progress', {
            "items": [
              {
                "id": this.$store.getters.currentVoucher.id,
                "name": this.$store.getters.currentVoucher.name,
                "quantity": 1,
                "price": (this.$store.getters.currentVoucher.price / 100),
              }
            ],
            "coupon": "SUMMER_DISCOUNT"
          })
        }
      }
    }

  }</script>

<style lang="scss" scoped>
</style>
